import Header from "@/components/Header"
import Sidebar from "@/components/Sidebar"
import { operatorInternasionalNavigations } from "@/constants"
import { useUser } from "@/hooks/useUser"
import { Navigate, Outlet } from "react-router-dom"

export default function OperatorInternasionalLayout() {
  const { user, isPending } = useUser()
  const userRoles = user?.jenis_user || []
  const operatorInternasional =
    userRoles.includes("operator_internasional") || false

  if (!isPending && !operatorInternasional) return <Navigate to={"/"} />

  return (
    <main className="flex">
      <Sidebar navigationMenus={operatorInternasionalNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  )
}
